module.exports = __webpack_public_path__ + "static/media/edge.8ea8e880.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/edge.png
// module id = 92
// module chunks = 0